<template>
  <div class="">
    <div v-if="jobs.length > 0">
      <section class="d-sm-flex">
        <section class="me-4 mb-3 filter-container">
          <label for="category" class="form-label museo">Yrkeskategori</label>
          <select v-model="selectedCategory" class="form-select" id="category">
            <option value="all">Alla yrkeskategorier</option>
            <option v-for="category in categoriesOrdered" :key="category.id" :value="category.id">{{ category.name }}</option>
          </select>
        </section>

        <section class="me-4 mb-3 filter-container">
          <p class="form-label museo">Anställningsform</p>

          <div v-for="(empType, index) in empTypes" :key="empType" class="d-inline-block" :class="{ 'ms-3': index !== 0 }">
            <input class="form-check-input" type="checkbox" v-model="selectedEmpTypeGroups" :value="empType" :id="empType">
            <label class="form-check-label ms-2" :for="empType">{{ empType }}</label>
          </div>
        </section>
      </section>

      <section>
        <section class="me-4 mb-3 filter-container">
          <label for="filter" class="form-label d-block museo">Sök i listan</label>

          <div class="p-input-icon-left d-block" style="min-width: 290px;">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" id="filter" class="form-control" />
          </div>
        </section>
      </section>

      <DataTable
        :pt="{
          // Target the header cell component
          headerCell: {
            root: ({ props, context }) => ({
              class: ['testing123', {
                'sortable-header': props.sortable,
                'sorted-header': props.sortField === props.field
              }],
              style: {
                // You can add inline styles here if needed
              },
              // Ensure proper ARIA attributes
              role: 'columnheader',
              ...(props.sortable && {
                'aria-sort': props.sortField === props.field
                  ? props.sortOrder === 1 ? 'ascending' : 'descending'
                  : 'none'
              })
            }),
            // If you need to target specific parts of the header cell
            sortIcon: {
              class: 'custom-sort-icon'
            },
            sortBadge: {
              class: 'custom-sort-badge'
            }
          },
          // You can also style other parts of the table
          table: {
            class: 'custom-table'
          },
          thead: {
            class: 'custom-thead'
          },
          tbody: {
            class: 'custom-tbody'
          }
        }"
        :value="jobsFiltered"
        sortField="titleLocale"
        :sortOrder="1"
        dataKey="id"
        v-model:filters="filters"
        filterDisplay="menu"
        stripedRows
        :showGridlines=false
        responsiveLayout="stack"
        breakpoint="581px"
        class="p-datatable-sm mt-4"
      >
        <template #empty>
          Inget resultat hittades...
        </template>

        <TableColumn field="titleLocale" header="Jobbtitel" :sortable="true">
          <template #body="{data}">
            <span style="word-break: break-word; hyphens: auto;">
              <router-link :to="{ name: 'jobView', params: { id: data.id }}">
                {{ data.titleTrimmed.replace('/', '/&shy;') }}
              </router-link>
            </span>
          </template>
        </TableColumn>

        <TableColumn field="org_descLocale" header="Verksamhet" :sortable="true">
          <template #body="{data}">
            <span style="word-break: break-word; hyphens: auto;">
              {{ data.org_descTrimmed.replace('/', '/&shy;') }}
            </span>
          </template>
        </TableColumn>

        <TableColumn field="deadline" header="Ansök senast" :sortable="true">
          <template #body="{data}">{{ data.deadline ? data.deadline.split('T')[0] : '-' }}</template>
        </TableColumn>
      </DataTable>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import { FilterMatchMode } from 'primevue/api'
import { mapActions } from 'vuex'
// import store from '../store'

export default {
  name: 'ListView',

  data () {
    return {
      jobs: [],
      categories: [],
      allEmpTypes: [],
      empTypes: ['Tillsvidare', 'Visstid', 'Säsong'],
      // filters: {
      //   global: {
      //     value: null,
      //     matchMode: FilterMatchMode.CONTAINS
      //   }
      // },
      // selectedCategory: 'all',
      // selectedEmpTypeGroups: ['Tillsvidare', 'Visstid', 'Säsong'],
      empTypeGroupsMapping: {
        Tillsvidare: [
          'Tillsvidareanställning',
          'Tillsvidare med provanställning'
        ],
        Visstid: [
          'Visstidsanställning (kortare än 10 dagar)',
          'Visstidsanställning (kortare än 3 månader)',
          'Särskild visstidsanställning',
          'Tidsbegränsad anställning',
          'Visstidsanställning',
          'Vikariat'
        ],
        Säsong: [
          'Säsongsarbete',
          'Sommarjobb/Säsongsanställning'
        ]
      }
    }
  },

  computed: {
    // ...mapState(['selectedCategory', 'selectedEmpTypeGroups']),

    selectedCategory: {
      get () { return this.$store.state.selectedCategory },
      set (value) { this.$store.commit('setSelectedCategory', value) }
    },

    selectedEmpTypeGroups: {
      get () { return this.$store.state.selectedEmpTypeGroups },
      set (value) { this.$store.commit('setSelectedEmpTypeGroups', value) }
    },

    filters: {
      get () { return this.$store.state.filters },
      set (value) { this.$store.commit('setFilters', value) }
    },

    categoriesOrdered () {
      return this.categories.slice(0).sort((a, b) => a.name.localeCompare(b.name))
    },

    selectedEmpTypesIds () {
      return this.selectedEmpTypeGroups.map(empType => {
        return this.empTypeGroupsMapping[empType].map(item => this.allEmpTypes[item])
      }).flat()
    },

    jobsFiltered () {
      let jobs = this.jobs.map((job) => {
        if (job.employmentTypeId === null) {
          return {
            ...job,
            employmentTypeId: '2'
          }
        }

        return {
          ...job
        }
      })

      if (this.selectedCategory !== 'all') {
        jobs = this.jobs.filter(job => job.taxonomyId === this.selectedCategory)
      }

      jobs = jobs.filter(job => this.selectedEmpTypesIds.some((t) => job.employmentTypeId.includes(t)))

      return jobs
    }
  },

  methods: {
    ...mapActions(['sendPostMessageFrameHeight', 'sendPostMessageCategory', 'sendPostMessageFilter', 'sendPostMessageClearJobId']),

    addZs (phrase) {
      let res = phrase

      if (phrase.toLowerCase().charAt(0) === 'å') {
        res = 'z' + phrase
      } else if (phrase.toLowerCase().charAt(0) === 'ä') {
        res = 'zz' + phrase
      } else if (phrase.toLowerCase().charAt(0) === 'ö') {
        res = 'zzz' + phrase
      }

      return res
    }
  },

  watch: {
    selectedCategory (newVal) {
      let categoryName = 'all'

      if ((this.categories.find(category => category.id === newVal))?.name !== undefined) {
        categoryName = (this.categories.find(category => category.id === newVal))?.name
      }

      this.sendPostMessageCategory(categoryName)
    },

    'filters.global.value' (newVal) {
      this.sendPostMessageFilter(newVal !== '' ? newVal : null)

      this.$nextTick(() => {
        this.sendPostMessageFrameHeight()
      })
    },

    jobsFiltered () {
      this.$nextTick(() => {
        this.sendPostMessageFrameHeight()
      })
    }
  },

  mounted () {
    if (this.$route.query.clearJobId) {
      this.sendPostMessageClearJobId()
    }

    axios.get('https://app2.gotland.se/jobblista/proxy2.php')
      .then(resp => {
        this.jobs = resp.data.map(job => {
          return {
            ...job,
            titleTrimmed: job.title.trim(),
            titleLocale: this.addZs(job.title.trim()),
            org_descTrimmed: (job.organization || '-').trim(),
            org_descLocale: this.addZs((job.organization || '-').trim())
          }
        })

        this.$nextTick(() => {
          this.sendPostMessageFrameHeight()
        })
      })

    axios.get('https://app2.gotland.se/jobblista/proxy2.php?path=taxonomies')
      .then(resp => {
        this.categories = resp.data

        // if (store.state.initialCategory) {
        //   this.selectedCategory = (this.categories.find(category => category.name === store.state.initialCategory)).id
        // }
      })

    axios.get('https://app2.gotland.se/jobblista/proxy2.php?path=employment-types')
      .then(resp => {
        this.allEmpTypes = resp.data.reduce((acc, cur, i) => {
          acc[cur.name] = cur.id
          return acc
        }, {})
      })

    this.$nextTick(() => {
      setTimeout(() => {
        const headers = this.$el.querySelectorAll('th')

        headers.forEach(header => {
          header.setAttribute('role', 'columnheader')
        })
      }, 500)
    })
  }
}
</script>
<style lang="scss" scoped>

@media (max-width: 767px) {
  .filter-container {
    width: 100%;
  }
}

</style>
